import { ClienteApi } from "app/api/classes/ClienteApi";
import { SegurancaApi } from "app/api/classes/SegurancaApi";
import microuniversoApi from "app/api/microuniversoApi";
import { PagedMessageResponse } from "app/api/types/PagedMessageResponse";
import { PesquisarFornecedoresController } from "app/controllers/fornecedor/pesquisarFornecedoresController";
import { PesquisarClassesProdutosController } from "app/controllers/produtos/pesquisarClassesProdutosController";
import { useAppSelector } from "app/redux/hooks";
import { ControllerLegado } from "app/types/ControllerLegado";
import { Parametro } from "app/types/Parametro";
import { tratamentoErroPadrao } from "app/use-cases";
import { obterParametros } from "app/use-cases/parametro/obterParametros";
import { BreadCrumb } from "breadcrumb";
import globalMU from "globalMU";
import React, { useEffect, useRef, useState } from "react";
import { Breadcrumb2Container } from "../breadcrumb2/Breadcrumb2Container";
import { removerBreadcrumbOriginal } from "../breadcrumb2/breadcrumb2Utils";
import { removerComponenteReact, renderizarComponentReact } from "../renderizarOuRemoverComponentReact";
import { ColunaUltimasCompras, PesquisaUltimasCompras, Produto, UltimasCompras, UltimasComprasItem } from "./UltimasCompras";
import * as R from 'ramda'
//import { PesquisarProdutosController } from "app/controllers/produtos/pesquisarProdutosController";
import { Dict } from "app/utils/Dict";
import { PesquisaClasseContainer } from "../pesquisa-produtos/pesquisa-classe/PesquisaClasseContainer";
import { PesquisaFornecedorContainer } from "../pesquisa-produtos/pesquisa-fornecedor/PesquisaFornecedorContainer";
import { PaginaPesquisaProdutoContainer } from "../pesquisa-produtos/PaginaPesquisaProdutoContainer";
const Backbone = require('backbone')

type NomesTelas = "UltimasCompras" | "PesquisaProduto" | "PesquisarClasses" | "PesquisarFornecedores"

export type UltimasComprasContainerProps = {
    dadosCliente?: {
        cpfCnpj: string
        nome: string
        codigo: number
    }
    pesquisarClientesController?: ControllerLegado
    codigoCliente?: number
    onVoltar?: () => void;
    passos?: Dict<string, () => void>;
    onRemover?: () => boolean
    produtosSelecionados?: Produto[]
    classe?: string
    fornecedor?: {
        Codigo: string
        Nome: string
    }
}


export const UltimasComprasContainer = (props: UltimasComprasContainerProps) => {
    const isMounted = useRef(true)
    const orcamento = useAppSelector(store => store.orcamento)
    const [ultimasCompras, setUltimasCompras] = useState<PagedMessageResponse<UltimasComprasItem>>();
    const [classeSelecionada, setClasseSelecionada] = useState<string>(props.classe)
    const [parametros, setParametros] = useState<Parametro[]>([])
    const [colunas, setColunas] = useState<ColunaUltimasCompras[]>([])
    const [numeroPagina, setNumeroPagina] = useState(1)
    const pesquisarClassesProdutosControllerRef = useRef(null)
    const pesquisarFornecedoresControllerRef = useRef(null)
    const pesquisarProdutosControllerRef = useRef(null)
    const [fornecedorSelecionado, setFornecedorSelecionado] = useState<{
        Codigo: string
        Nome: string
    }>(props.fornecedor)
    const [mostrarComponente, setMostrarComponente] = useState(true)
    const [mostrarMaisFiltros, setMostrarMaisFiltros] = useState(false)
    const [tamanhoFonte, setTamanhoFonte] = useState(13)
    const [numeroCasasDecimaisQuantidade, setNumeroCasasDecimaisQuantidade] = useState(2)
    const [numeroCasasDecimaisPreco, setNumeroCasasDecimaisPreco] = useState(2)
    const [produtosSelecionados, setProdutosSelecionados] = useState<Produto[]>(props.produtosSelecionados)
    const [processando, setProcessando] = useState(false)
    const [dadosPesquisa, setDadosPesquisa] = useState<PesquisaUltimasCompras>(null)


    const passosInterno = props.passos && useRef<Dict<string, () => void>>(new Dict(Object.assign({}, props.passos.map)))

    const breadcrumbRef = useRef(BreadCrumb.getInstance())

    const montarFiltrosPesquisa = (dadosPesquisa: PesquisaUltimasCompras, paginaNumero: number) => ({
        ...dadosPesquisa,
        CodigoFornecedor: fornecedorSelecionado?.Codigo,
        CodigoCliente: props.dadosCliente ? props.dadosCliente.codigo : props.codigoCliente,
        NumeroPagina: paginaNumero,
        TamanhoPagina: 20

    } as ClienteApi.ListarComprasRequisicao)

    const atualizarUltimasCompras = async ({
        numeroPagina_
    }: {
        numeroPagina_?: number
    } = {}) => {
        if (!isMounted.current) return;
        try {
            globalMU.blockUI();
            setProcessando(true)

            setUltimasCompras(
                await microuniversoApi.Cliente.ListarCompras({
                    CodigoCliente: props.dadosCliente ? props.dadosCliente.codigo : props.codigoCliente,
                    NumeroPagina: 1,
                    CodigosProdutos: (produtosSelecionados ?? []).map(p => p.Codigo)
                })
            )

        } catch (e) {
            tratamentoErroPadrao(e);
        } finally {
            setProcessando(false)
            globalMU.unblockUI();
        }
    }

    const pesquisarUltimasCompras = async (dadosPesquisa: PesquisaUltimasCompras, numeroPagina: number) => {

        if (!isMounted.current) return;
        try {
            globalMU.blockUI();
            setProcessando(true)
            if (numeroPagina == null || numeroPagina == undefined)
                numeroPagina = 1
            setDadosPesquisa({ ...dadosPesquisa, NumeroPagina: numeroPagina }) // 471897

            setUltimasCompras(
                await microuniversoApi.Cliente.ListarCompras(montarFiltrosPesquisa(dadosPesquisa, numeroPagina))
            )

        } catch (e) {
            tratamentoErroPadrao(e);
        } finally {
            setProcessando(false)
            globalMU.unblockUI();
        }
    }

    const pesquisarClasse = () => {
        if (!isMounted.current) return;
        setMostrarComponente(false)


        props.pesquisarClientesController ? (
            pesquisarClassesProdutosControllerRef.current = props.pesquisarClientesController.showView({
                region: {
                    name: "pesquisarClassesProdutosRegion",
                    selector: "#pesquisar-classes-produtos-ultimas-compras-region"
                },
                controller: {
                    type: PesquisarClassesProdutosController,
                    args: {
                        classeSelecionadaCallback: classeSelecionada_ => {
                            setClasseSelecionada(classeSelecionada_.ClasseProduto)
                            pesquisarClassesProdutosControllerRef.current.hide()
                            props.pesquisarClientesController.mostrarComponenteReactAtual()
                            removerBreadcrumbOriginal()
                            setMostrarComponente(true)
                            setMostrarMaisFiltros(true)
                        }
                    }
                }
            })
        ) : (
            renderizarComponentReact(<PesquisaClasseContainer
                onSelecionadoClasse={(classe) => {
                    renderizarComponentReact(<UltimasComprasContainer {...props} classe={classe} />, "conteudo-pagina", true)
                    setClasseSelecionada(classe)
                }}

                onVoltar={() => renderizarComponentReact(<UltimasComprasContainer {...props} />, "conteudo-pagina", true)}
                passos={passosInterno.current}
                regiaoRenderizada="conteudo-pagina" />, "conteudo-pagina", true)
        )

    }

    const pesquisarFornecedor = () => {
        if (!isMounted.current) return;
        setMostrarComponente(false)

        props.pesquisarClientesController ? (
            pesquisarFornecedoresControllerRef.current = props.pesquisarClientesController.showView({
                region: {
                    name: "pesquisarFornecedoresRegion",
                    selector: "#pesquisar-fornecedores-ultimas-compras-region"
                },
                controller: {
                    type: PesquisarFornecedoresController,
                    args: {
                        fornecedorSelecionadoCallback: fornecedor => {
                            setFornecedorSelecionado({
                                Codigo: fornecedor.get("CodigoInterno"),
                                Nome: fornecedor.get("Nome")
                            })

                            pesquisarFornecedoresControllerRef.current.hide()
                            props.pesquisarClientesController.mostrarComponenteReactAtual()
                            removerBreadcrumbOriginal()
                            setMostrarComponente(true)
                            setMostrarMaisFiltros(true)
                        }
                    }
                }

            })

        ) : (

            renderizarComponentReact(<PesquisaFornecedorContainer
                onSelecionadoFornecedor={(codigoFornecedor, nomeFornecedor) => {
                    renderizarComponentReact(<UltimasComprasContainer {...props}
                        fornecedor={{
                            Codigo: codigoFornecedor,
                            Nome: nomeFornecedor
                        }}
                    />, "conteudo-pagina", true)

                    setFornecedorSelecionado({
                        Codigo: codigoFornecedor,
                        Nome: nomeFornecedor
                    })
                }}

                onVoltar={() => renderizarComponentReact(<UltimasComprasContainer  {...props} />, "conteudo-pagina", true)}
                passos={passosInterno.current}
                regiaoRenderizada="conteudo-pagina" />, "conteudo-pagina", true)
        )


    }

    const atualizarParametros = async () => {
        if (!isMounted.current) return;
        const parametros_ = await obterParametros({
            nomes: [
                "CHAVE_MOVIMENTACAO_ORCAMENTO",
                "ORCAMENTO_MASCARA_QUANTIDADE",
                "CASAS_DECIMAIS_PRECO_VENDA"
            ]
        })

        setParametros(parametros_)

        setNumeroCasasDecimaisQuantidade(
            globalMU.resolverNumeroCasasDecimaisDeParametroFormatado(
                parametros_.find(p => p.Nome == "ORCAMENTO_MASCARA_QUANTIDADE")?.Valor,
                3
            )
        )

        setNumeroCasasDecimaisPreco(
            isNaN(Number(valorParametro("CASAS_DECIMAIS_PRECO_VENDA") || undefined)) ? 2 : Number(valorParametro("CASAS_DECIMAIS_PRECO_VENDA"))
        )
    }

    const atualizarDadosGrid = async () => {
        if (!isMounted.current) return;
        const dadosGrid = await microuniversoApi.Seguranca.obterDadosGrid("Orcamento", "PESQUISAR_ULTIMAS_COMPRAS_CLIENTE")

        const ordemColunas = [
            "Data", "NumeroOrcamento", "Vendedor", "FormaPagamento", "Lote", "Tonalidade", "Bitola", "QuantidadeLote",
            "ValidadeLote", "QuantidadeItem", "CodigoProduto", "Produto", "Preço", "SistemaTintometrico", "NomeCor", "ModeloProduto"
        ]

        const colunasParaRemover = [
            "Acoes"
        ]

        const removerColunas = (colunas_: SegurancaApi.AtualizarGridResposta["Colunas"]) => {
            return colunas_.filter(c => !colunasParaRemover.includes(c.Nome))
        }

        const ordenarColunas = (colunas_: SegurancaApi.AtualizarGridResposta["Colunas"]) => {
            return colunas_.map(c => ({
                ...c,
                Ordem: ordemColunas.findIndex(o => o == c.Nome)
            }) as ColunaUltimasCompras)
        }

        setColunas(
            R.pipe(
                removerColunas,
                ordenarColunas
            )(dadosGrid.Colunas)
        )

        setTamanhoFonte(dadosGrid.TamanhoFonte)
    }

    const valorParametro = (nome: string) => (parametros ?? []).find(p => p.Nome == nome)?.Valor

    const voltarCadastroCliente = () => {
        if (!isMounted.current) return;
        removerComponenteReact("pesquisa-cliente-orcamento-region-react")
        //renderizarComponentReact(PesquisarClienteContainer, "pesquisa-cliente-orcamento-region-react", true)
    }

    const onPassoSelecionado = (passo: string) => {
        if (!isMounted.current) return;
        if (props.passos) {
            props.onRemover()
            passosInterno.current.get(passo)()
        } else {
            if (passo == "Cadastro Cliente") {
                breadcrumbRef.current.navegarAPartirDoReact(0)
            }
        }
    }

    const onVoltar = () => {
        if (!isMounted.current) return;
        if (props.passos) {
            props.onRemover()
            props.onVoltar()
        } else {
            breadcrumbRef.current.navegarAPartirDoReact(0)
        }

    }

    const regionsComponentesLegados = `
        <div id="pesquisar-classes-produtos-ultimas-compras-region" style="display: none;" region></div>
        <div id="pesquisar-fornecedores-ultimas-compras-region" style="display: none;" region></div>
        <div id="pesquisar-produto-ultimas-compras-region" style="display: none;" region></div>
    `

    useEffect(() => {
        props.passos && passosInterno.current.set("Últimas Compras", () => renderizarComponentReact(<UltimasComprasContainer {...props} />, "conteudo-pagina", true))
        const inicializar = async () => {
            await Promise.all([
                atualizarUltimasCompras(),
                atualizarParametros(),
                atualizarDadosGrid()
            ])
        }

        inicializar()

        return () => {
            isMounted.current = false;
        }
    }, [])


    return <>


        <div dangerouslySetInnerHTML={{ __html: regionsComponentesLegados }}></div>

        {mostrarComponente && <>

            <Breadcrumb2Container
                passos={props.passos ? passosInterno.current.keysToList() : ["Cadastro Cliente", "Últimas Compras"]}
                exibirBotaoLimpar={false}
                exibirBotaoVoltar={true}
                id="UltimasComprasContainer"
                onBotaoLimparClicado={voltarCadastroCliente}
                onPassoSelecionado={onPassoSelecionado}
                onBotaoVoltarClicado={onVoltar}
            />

            <UltimasCompras
                processando={processando}
                onPesquisaClasse={pesquisarClasse}
                onPesquisaFornecedor={pesquisarFornecedor}
                onLimparFornecedor={() => {
                    setFornecedorSelecionado(null)
                }}
                onPesquisar={pesquisarUltimasCompras}
                onPesquisarProdutos={() => {

                    setMostrarComponente(false)
                    {/*
                    props.pesquisarClientesController ? (
                        pesquisarProdutosControllerRef.current = props.pesquisarClientesController.showView({
                            region: {
                                name: "pesquisarProdutosUltimasComprasRegion",
                                selector: "#pesquisar-produto-ultimas-compras-region"
                            },
                            controller: {
                                type: PesquisarProdutosController,
                                args: {
                                    model: new Backbone.Model(orcamento),
                                    orcamento: new Backbone.Model(orcamento),
                                    adicionarProdutosCallback: (produtosSelecionados_: any[]) => {
                                        pesquisarProdutosControllerRef.current.hide()
                                        setMostrarComponente(true)
                                        setProdutosSelecionados(
                                            produtosSelecionados_.map(p => ({
                                                Codigo: p.Codigo,
                                                Descricao: p.Descricao
                                            } as Produto))
                                        )
    
                                    },
                                    esconderForaEstoque: true
                                }
                            }
                        })
                    ) : (
                        */}
                    renderizarComponentReact(<PaginaPesquisaProdutoContainer
                        chamadoParaInserirProdutoNoOrcamento={false}
                        chamadoPeloTrocarProduto={false}
                        ocultarBarraPesquisa={true}
                        adicionarProdutos={(produtosSelecionados) => {
                            setProdutosSelecionados(produtosSelecionados.map(produto => ({ Codigo: produto.Codigo, Descricao: produto.Descricao })))

                            renderizarComponentReact(<UltimasComprasContainer {...props}
                                produtosSelecionados={produtosSelecionados.map(produto => ({ Codigo: produto.Codigo, Descricao: produto.Descricao }))} />, "conteudo-pagina", true)
                        }}
                        passos={passosInterno.current}
                        esconderForaEstoque={true}
                        onVoltar={() => renderizarComponentReact(<UltimasComprasContainer  {...props} />, "conteudo-pagina", true)}
                        regiaoRenderizada="conteudo-pagina" />, "conteudo-pagina", true)
                    {/*  
                    )
                 */}
                }}

                onExcluirProdutoLista={codigoProduto => {
                    setProdutosSelecionados(produtosSelecionados.filter(p => p.Codigo != codigoProduto))
                }}
                onAlterarListaSelecionada={function (numeroIndexPagina: number): void {

                }}
                onAlterarFonte={async tamanho => {
                    await microuniversoApi.Usuario.alterarFonte("PESQUISAR_ULTIMAS_COMPRAS_CLIENTE", tamanho)
                    setTamanhoFonte(tamanho)

                }}
                onToggleColunaSelecionada={async (nome, selecionada) => {
                    await microuniversoApi.Seguranca.atualizarGrid({
                        CodigoUsuario: globalMU.userIdForGrid(),
                        Modulo: "Orcamento",
                        NomeGrid: "PESQUISAR_ULTIMAS_COMPRAS_CLIENTE",
                        Token: globalMU.token(),
                        Colunas: colunas.map(c => ({
                            ...c,
                            Selecionada: c.Nome == nome ? selecionada : c.Selecionada
                        }) as SegurancaApi.AtualizarGridRequisicao["Colunas"][0])
                    })

                    await atualizarDadosGrid()
                }}
                onToggleSelecionarTodasColunas={async (selecionar) => {
                    await microuniversoApi.Seguranca.atualizarGrid({
                        CodigoUsuario: globalMU.userIdForGrid(),
                        Modulo: "Orcamento",
                        NomeGrid: "PESQUISAR_ULTIMAS_COMPRAS_CLIENTE",
                        Token: globalMU.token(),
                        Colunas: colunas.map(c => ({
                            ...c,
                            Selecionada: selecionar
                        }) as SegurancaApi.AtualizarGridRequisicao["Colunas"][0])
                    })

                    await atualizarDadosGrid()
                }}
                tamanhoFonte={tamanhoFonte}
                cpfcnpj={props.dadosCliente ? props.dadosCliente.cpfCnpj : orcamento?.Cliente?.CpfCnpj ?? ''}
                nome={props.dadosCliente ? props.dadosCliente.nome : orcamento?.Cliente?.Nome ?? ''}
                mascara={""}
                pesquisaUltimasCompras={{
                    ClasseProduto: classeSelecionada,
                    CodigoCliente: 0,
                    CodigoFornecedor: "",
                    CodigoProduto: null,
                    CodigosProdutos: [],
                    DataFinal: "",
                    DataInicial: "",
                    DescricaoProduto: "",
                    NumeroPagina: 0,
                    ReferenciaProduto: "",
                    TamanhoPagina: 0
                }}
                produtosSelecionados={produtosSelecionados}
                loteVencido={false}
                ultimasCompras={ultimasCompras}
                exibirCodigoOuReferencia={valorParametro("CHAVE_MOVIMENTACAO_ORCAMENTO") == "C" ? "CODIGO" : "REFERENCIA"}
                colunas={colunas}
                descricaoProduto={""}
                classe={classeSelecionada}
                nomeFornecedor={fornecedorSelecionado?.Nome ?? ""}
                mostrarMaisFiltros={mostrarMaisFiltros}
                numeroCasasDecimaisQuantidade={numeroCasasDecimaisQuantidade}
                numeroCasasDecimaisPreco={numeroCasasDecimaisPreco}
                exibirLupaPesquisaDeProdutos={globalMU.isNotNullOrEmpty(orcamento?.IdentificadorOrcamento)}
                onNumeroPaginaModificado={numeroPagina_ => {
                    setNumeroPagina(numeroPagina_)
                    //471897 atualizarUltimasCompras({ numeroPagina_ })

                    pesquisarUltimasCompras(dadosPesquisa, numeroPagina_) // 471897
                }}
            />
        </>}
    </>
}
